import { forwardRef, useImperativeHandle } from 'react';
import { ContactOrPurposeSectionCoCo } from '../shared/ContactOrPurposeSectionCoCo.js';
import type { ConfigHandle, ProductConfigProps } from '../productConfigTypesCoCo.js';

export const SoftwareProductConfigCoCo = forwardRef<ConfigHandle, ProductConfigProps>(
  ({ basketItem, orderItem, schema, contactFormRefs, contactsUpdateMethods }, ref) => {
    const cartItemInstanceId = `${basketItem.id}-${orderItem.basketItemIndex}`;

    // SoftwareProductConfigCoCo has no inner form — the contact form ref handles all validation
    // by being collected into contactFormRefs in ProductsStepCoCo.
    useImperativeHandle(
      ref,
      () => ({
        validate: async () => true,
        scrollToFirstError: () => {},
        getErrorCount: () => 0,
      }),
      []
    );

    return (
      <div id={`software-config-${cartItemInstanceId}`}>
        <ContactOrPurposeSectionCoCo
          schema={schema}
          orderItem={orderItem}
          contactFormRefs={contactFormRefs}
          contactsUpdateMethods={contactsUpdateMethods}
          isMandatory={true}
          showAccordion={true}
          showUserContact={true}
        />
      </div>
    );
  }
);

SoftwareProductConfigCoCo.displayName = 'SoftwareProductConfigCoCo';
